import React from 'react'
import { useDispatch } from 'react-redux'
import { XIcon } from 'lucide-react'
import IconButton from '@mui/material/IconButton'
import { pageToggleRight } from 'redux/actions'

export default function ExpiredLegislation (props) {
  const dispatch = useDispatch()

  return (
    <div>
      <section className='flex justify-between items-center bb b--grey pt7 pb6 bg-page-background '>
        <div className='flex items-center justify-between w-100'>
          Unmaintained Legislation Reference
        </div>
        <IconButton
          onClick={() => dispatch(pageToggleRight(false))}
          className='pointer black hover-cadet-blue'
          size='small'
        >
          <XIcon />
        </IconButton>
      </section>
      <p className='mv7'>
        This legislation reference is no longer maintained by our service. Please refer to the most recent legislation for accurate and up-to-date information.
      </p>
    </div>
  )
}
